import './customer_widget.scss'
import '../../borrower_widget.scss'
import {BorrowerWidget} from "../../borrowerWidget";

export class CustomerWidget {

    static instance = BorrowerWidget.wrapperInstanceFactory({
        template: require('./customer_widget.html')
    })

}